<template>
    <div  class="mybtn">
        <el-button
        :color="bgColor"
        style="width: 100%;height: 34px;margin-top: 5px;color:#2A2A2A;"
        :style="{'background-color':selectBtn1?bgColor:'','border-color':selectBtn1?cricleColor:'#BDBDBD'}"
        plain
         @click='btnFun()'
        >
            <div style="width: 20px;">
              <div v-if='!selectBtn1' class="cricle" :style="{'background-color':cricleColor}"></div>
              <el-Icon v-else class="select" :style="{'color':cricleColor}"><Select/></el-Icon>
            </div>
            <div class="solt">
             <slot ></slot>
            </div>
            <p style="width:20px;color:#BDBDBD ; font-size: 13px;margin-top: 10px;">{{ keyWord }}</p>
        </el-button>
    </div>
</template>

<script>
// import { isDark } from '~/composables/dark'
export default {
  name: 'myButton',
  props: {
    text: {
      type: String,
      default: ''
    },
    bgColor: {
      type: String,
      default: '#FFCCF1'
    },
    cricleColor: {
      type: String,
      default: '#FF00B8'
    },
    selectBtn: {
      type: Boolean,
      default: false
    },
    keyWord: {
      type: String,
      default: ''
    },
    poorBtn: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      showIcon: false,
      selectBtn1: false
    }
  },
  created () {
    // window.addEventListener('keydown', this.keyupFun, true)
  },
  beforeUnmount () {
    // window.removeEventListener('keydown', this.keyupFun, true)
  },
  watch: {
    selectBtn (newval, oldval) {
      console.log('newval', newval)
      this.selectBtn1 = newval
    }
  },
  methods: {
    btnFun () {
    //   this.showIcon = !this.showIcon
      if (this.$store.state.list.length !== 0 && !this.poorBtn) {
        this.$emit('clickFun')
      }
    },
    keyupFun (e) {
      // console.log('keyup', e.key, e.keyCode)
      // e.preventDefault()
      if (this.$store.state.list.length !== 0 && !this.poorBtn) {
        if (e.key === 'F1' || e.key === 'F2' || e.key === 'F3' || e.key === 'F4' || e.key === 'F5' || e.key === 'F6' || e.key === 'F7' || e.key === 'F8') {
          e.preventDefault()
          this.$emit('keyFun', e.key)
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
.el-button{
    justify-content:left;
    div{
        margin-right: 10px;
    }
    font-weight: 700;
    font-size: 16px;
    border-color: #2A2A2A;
    .solt{
      text-align: left;
      width: 100%;
    }
 }

 .cricle{
    width:20px;
    height:20px;
    background:#ffffff;
    border-radius:50%;
    margin-right:20px ;
 }
 .select{
    font-size: 20px;
    margin-right: 10px;
 }
</style>
<style lang="less">
 .mybtn .el-button>span {
    display: inline-flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
}
</style>
